import { render, staticRenderFns } from "./OutstandingAccountSubList.vue?vue&type=template&id=8f23d8c0"
import script from "./OutstandingAccountSubList.vue?vue&type=script&lang=js"
export * from "./OutstandingAccountSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports